(() => {
  const initialize = (root) => {
    root.querySelectorAll('.organax-details').forEach((section) => {
      if (section.dataset.tabsReady === 'true') return;
      // Remove only a standalone leading imported label, preserving the copy.
      const description = section.querySelector('[data-product-description]');
      if (description) {
        const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
        let first;
        while ((first = walker.nextNode()) && !first.textContent.trim()) {}
        if (first && /^product\s+description\s*:?$/i.test(first.textContent.trim())) {
          let label = first.parentElement;
          while (label.parentElement !== description && /^product\s+description\s*:?$/i.test(label.parentElement.textContent.trim())) label = label.parentElement;
          if (label !== description && /^product\s+description\s*:?$/i.test(label.textContent.trim())) label.remove();
          else first.remove();
        }
      }
      const tabs = [...section.querySelectorAll('[role="tab"]')];
      const panels = [...section.querySelectorAll('[role="tabpanel"]')];
      if (!tabs.length) return;
      section.dataset.tabsReady = 'true';

      const activate = (tab, focus = false) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = panels.find((candidate) => candidate.id === item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) tab.focus();
      };

      activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[next], true);
          tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
